import { faCheckCircle, faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Spinner } from "react-bootstrap";
import type { AsyncStatus } from "../../components/types";

type ConfigurationStatusIndicatorProps = {
  status: AsyncStatus;
  pendingLabel?: string;
  countdown?: number;
};

const formatCountdown = (seconds: number): string => {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
};

/** Renders the pending / success / failed pill used for async gateway operations. */
export function ConfigurationStatusIndicator({
  status,
  pendingLabel = "Pending",
  countdown,
}: ConfigurationStatusIndicatorProps) {
  if (status === "pending") {
    const countdownText = countdown !== undefined && countdown > 0
      ? ` (${formatCountdown(countdown)})`
      : "";
    return (
      <span className="gateway-config-status gateway-config-status--pending">
        {pendingLabel}
        {countdownText && <span className="gateway-config-status__countdown">{countdownText}</span>}
        <Spinner
          animation="border"
          variant="primary"
          size="sm"
          className="ms-2"
        />
      </span>
    );
  }

  if (status === "success") {
    return (
      <span className="gateway-config-status gateway-config-status--success">
        <FontAwesomeIcon icon={faCheckCircle} className="gateway-config-status__icon" />
        Success
      </span>
    );
  }

  if (status === "failed") {
    return (
      <span className="gateway-config-status gateway-config-status--failed">
        <FontAwesomeIcon icon={faCircleExclamation} className="gateway-config-status__icon" />
        Failed
      </span>
    );
  }

  return null;
}
